import { Module } from "../modules/module";
import { initializeApp } from "./App";
/**
 * Boots the client UI layer so browser-based overlays and controls are registered through the same module start-up flow as the rest of the client.
 */
export class UIModule extends Module {
    constructor() {
        super("UIModule");
    }
    /**
     * Initializes the UI root and registers the UI-facing services, stores and render hooks needed by the client interface.
     */
    init() {
        initializeApp();
    }
}
